import React from 'react';

export const getRandomInt = (max, min=0) => () => {
  min = min>max ? 0 : min;
  return Math.floor(Math.random() * (max - min)) + min;
}

export const getRandomValueFromArray = (arr=[]) => (l=arr.length) => 
  (Array.isArray(arr) && l>0) ?
    l>1 ? arr[Math.floor(Math.random() * l)] : arr[0]
    :
    '';

export const nl2Br = (str,nlRegex = /(\r\n|\r|\n)/) =>
  typeof str === 'string' ?
    str.split(nlRegex).map((line, index) => line.match(nlRegex) ? React.createElement('br', { key: index }) : line)
    :
    str;



// WEBPACK FOOTER //
// ./src/Functions.js